import React, { useState, useEffect, useMemo } from "react";
import "./index.scss";
import { createNonceStr, md5, getLocationSearch } from "@/utils/utils";
import { queryAdvanceRule } from "@/api";
import request from "@/utils/request";
import { Modal, Icon, Toast } from "antd-mobile";
import testData from "./test.json";
import { getHelpLang, getHelpContent } from "./content";

// import Header from '@/components/header'
// import rightBtn from '@/assets/images/rightbtn.png'
const Help = (props) => {
  const [text, setText] = useState("");
  const lang = useMemo(() => getHelpLang(), []);
  const t = useMemo(() => getHelpContent(lang), [lang]);
  const columns = [
    { header: t.table.timePeriod, accessor: "timePeriod" },
    { header: t.table.startingPrice, accessor: "startingPrice" },
    { header: t.table.mileagePrice, accessor: "mileagePrice" },
    { header: t.table.durationPrice, accessor: "durationPrice" },
    { header: t.table.longDistance20, accessor: "longDistance20Price" },
    { header: t.table.longDistance30, accessor: "longDistance30Price" },
  ];

  const formatData = (data) => {
    return data.map((item) => {
      let timePeriod = item.memo 
        ? `${new Date(item.startTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}-${new Date(item.endTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}` 
        : (lang === 'en-US' ? "All Day" : (lang === 'zh-TW' ? "全天" : "全天"));
      return {
        timePeriod,
        startingPrice: item.startPrice,
        mileagePrice: item.distancePrice,
        durationPrice: item.timePrice,
        longDistance20Price: item.longDistancePrice1,
        longDistance30Price: item.longDistancePrice2,
      };
    });
  };

  const data1 = formatData(testData.ruleDetailDTOList.filter(item => item.userType === 2 && item.dayType === 1));
  const data2 = formatData(testData.ruleDetailDTOList.filter(item => item.userType === 2 && item.dayType === 2));

  let token = getLocationSearch().token;
  let tenantTag = getLocationSearch().tenantTag;
  const initRequest = async () => {
    let appKey = "app_h5";
    let secret = "11dc72cf-88b0-46cd-91d7-b1a77fd69ee1";
    let timestamp = new Date().getTime();
    let random = createNonceStr();
    let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
    let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
    Toast.loading("loading...", 0, () => {}, true);
    const res = await request.get(
      queryAdvanceRule,
      { token },
      {
        appKey: appKey,
        timestamp: timestamp,
        random: random,
        token: token,
        sign: sign,
        lang: lang,
      }
    );
    Toast.hide();
    if (res.data.data) {
      setText(res.data.data);
    }
  };
  useEffect(() => {
    initRequest();
  }, []);
  const s = t.sections;
  return (
    <div className="help__box">
      <div className="help-con">
        <div className="help__list">
          <div className="help__list__show">
            {text ? (
              <div className="help-con__list">
                <h2>{s.advanceRule}</h2>
                <p
                  dangerouslySetInnerHTML={{ __html: text }}
                  className="d_rule"
                ></p>
              </div>
            ) : null}
            <div className="help-con__list">
              <h2>{s.listenDispatch.title}</h2>
              <h3>{s.listenDispatch.q1}</h3>
              <h4>{s.listenDispatch.q1Sub}</h4>
              <p>{s.listenDispatch.q1a1}</p>
              <p>{s.listenDispatch.q1a2}</p>
              <h3>{s.listenDispatch.q2}</h3>
              <p>{s.listenDispatch.q2a}</p>
            </div>
            <div className="help-con__list">
              <h2>{s.order.title}</h2>
              <h3>{s.order.q1}</h3>
              <p>{s.order.q1a}</p>
              <h3>{s.order.q2}</h3>
              <p>{s.order.q2a}</p>
              <h3>{s.order.q3}</h3>
              <p>{s.order.q3a}</p>
              <h3>{s.order.q4}</h3>
              <p>{s.order.q4a}</p>
            </div>
            <div className="help-con__list">
              <h2>{s.withdraw.title}</h2>
              <h3>{s.withdraw.q1}</h3>
              <p>{s.withdraw.q1a}</p>
              <h3>{s.withdraw.q2}</h3>
              <p>{s.withdraw.q2a}</p>
            </div>
            <div className="help-con__list">
              <h2>{s.reward.title}</h2>
              <h3>{s.reward.q1}</h3>
              <h4>{s.reward.q1Sub}</h4>
              <p>{s.reward.q1a1}</p>
              <p>{s.reward.q1a2}</p>
              <p>{s.reward.q1a3}</p>
              <h3>{s.reward.q2}</h3>
              <p>{s.reward.q2a}</p>
            </div>
            <div className="help-con__list">
              <h2>{s.driverService.title}</h2>
              <h3>{s.driverService.q1}</h3>
              <p>{s.driverService.q1a}</p>
            </div>
            <div className="help-con__list">
              <h2>{s.extraFee.title}</h2>
              <h3>{s.extraFee.q1}</h3>
              <p>{s.extraFee.q1a}</p>
              <br />
              <p>{s.extraFee.q1Tip}</p>
            </div>

            {tenantTag=='ydrd'?<div className="help-con__list">
              <h2>{s.pricingRule.workday}</h2>
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      {columns.map((column) => (
                        <th key={column.accessor}>{column.header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data1.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {columns.map((column) => (
                          <td key={column.accessor}>{row[column.accessor]}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>:null}

            {tenantTag=='ydrd'?<div className="help-con__list">
              <h2>{s.pricingRule.restday}</h2>
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      {columns.map((column) => (
                        <th key={column.accessor}>{column.header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data2.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {columns.map((column) => (
                          <td key={column.accessor}>{row[column.accessor]}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>:null}

          </div>
        </div>
      </div>
    </div>
  );
};
export default Help;
